var map = {
	"./Gilded.png": 7110,
	"./Neon Blue.png": 83,
	"./Neon Green.png": 3536,
	"./Neon Pink.png": 8372,
	"./Practice Ball.png": 7199,
	"./Solana.png": 969,
	"./Standard Issue.png": 3801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7221;